/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import React, { useState } from 'react';
import { Button, message, Modal } from 'antd';
import { feedback as styles } from './header.styles';
import { get, set } from 'lodash';
import { useSelector } from 'react-redux';
import { InputLabel } from '../../_shared/input-label/input-label.component';
import { sendEmail } from '../../_shared/services/email.service';
import config from '../../config';
import appjson from '../../app.json';
import { getConfig, validateEmail } from '../../actions/utils';
import { useScreen } from '../../_shared/hooks/useScreen';

const DEFSTATE = JSON.stringify({
  open: false,
  loading: false,
  email: {
    subject: 'Feedback Email',
    from: '',
    replyTo: '',
    html: '',
  }
})

export default props => {
  const [state, setState] = useState({
    ...JSON.parse(DEFSTATE),
  })

  const { isMobile } = useScreen();
  const userEmail = useSelector(s => get(s, 'user.email', ''));

  const onClick = () => {
    setState(s => ({ ...s, open: true, email: { ...s.email, replyTo: get(s, 'email.replyTo') || userEmail } }));
  }

  const submit = async () => {
    try {
      const feedbackEmails = getConfig('feedbackEmails', config().feedbackEmails);
      setState(s => ({ ...s, loading: true }));

      const { html, from, subject, replyTo } = state.email;
      if (!html || !from || !replyTo) {
        setState(s => ({ ...s, loading: false }));
        return message.error('Please fill out all required fields before submitting');
      }

      if (!validateEmail(replyTo)) {
        setState(s => ({ ...s, loading: false }));
        return message.error('Please enter a valid email address');
      }

      const hostname = get(window, 'location.hostname');
      const instance = [get(appjson, 'APP_NAME'), hostname && `(${hostname})`].filter(f => !!f).join(' ');

      await sendEmail({
        to: feedbackEmails,
        replyTo,
        subject,
        html: `
          From: ${from}<br />
          Email: ${replyTo}<br />
          Message: ${html}<br /><br />
          Instance : ${instance}<br />
        `
      })
  
      setState({
        ...JSON.parse(DEFSTATE),
      })
  
      message.success(`Message sent successfully. Thank you for your feedback!`);
    } catch (err) {
      message.error(`Failed to send email: ${err.message}`);
      setState(s => ({ ...s, loading: false }));
    }
  }

  const changeContent = (e, key) => {
    const s = { ...state };
    set(s, key, e.target.value);
    setState(s);
  }

  if (isMobile) { return null };

  return (
    <>
      <Button type="primary" css={css(styles.button)} onClick={onClick}>
        Send Feedback
      </Button>

      <Modal 
        visible={get(state, 'open')}
        onOk={submit}
        confirmLoading={get(state, 'loading')}
        title={'Send Feedback'}
        onCancel={() => setState(s => ({ ...s, open: false }))}
      >
        <InputLabel label={'*From'} value={get(state, 'email.from')} onChange={e => changeContent(e, 'email.from')} />
        <InputLabel label={'*Email'} value={get(state, 'email.replyTo')} onChange={e => changeContent(e, 'email.replyTo')} />
        <InputLabel label={'*Message'} type="textarea" value={get(state, 'email.html')} onChange={e => changeContent(e, 'email.html')} />
      </Modal>
    </>
  )
}